import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Page extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { isDisabled, pageNumber, onClick } = this.props;
    e.preventDefault();
    if (isDisabled) {
      return;
    }

    onClick(pageNumber);
  }

  render() {
    const {
      pageText,
      /* pageNumber, */
      /* activeClass, */
      /* itemClass, */
      linkClass,
      activeLinkClass,
      /* disabledClass, */
      isActive,
      /* isDisabled, */
    } = this.props;

    /*
    const css = cx(itemClass, {
      [activeClass]: isActive,
      [disabledClass]: isDisabled,
    });
    */

    const linkCss = cx(linkClass, {
      [activeLinkClass]: isActive,
    });

    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a href="#" className={linkCss} onClick={this.handleClick}>
        { pageText }
      </a>
    );
  }
}

Page.propTypes = {
  pageText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  pageNumber: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  /* activeClass: PropTypes.string, */
  activeLinkClass: PropTypes.string,
  /* itemClass: PropTypes.string, */
  linkClass: PropTypes.string,
  /* disabledClass: PropTypes.string, */
};

Page.defaultProps = {
  /* activeClass: 'active', */
  /* disabledClass: 'disabled', */
  /* itemClass: undefined, */
  linkClass: undefined,
  activeLinkClass: undefined,
  isActive: false,
  isDisabled: false,
  pageText: undefined,
};
